import { inject, injectable } from "tsyringe";
import { ExtensionContext } from "../common/models/extension-config";
import { Module } from "../common/module";
import { CommonModule } from "./common.module";

@injectable()
export class ExtensionOperationsModule extends Module {
    public name: string = 'ExtensionOperationsModule';
    public acceptedLicenseFlags: string[] = [];


    constructor(@inject(CommonModule) private common: CommonModule) {
        super([common]);
    }

    public shouldRun(context: ExtensionContext): boolean { return context == ExtensionContext.vizql; }

    public async run(): Promise<void> {
        // wait for the first iframe (extension) element
        this.common.waitForElement('iframe', 60, document.body).then(e => {
            if (!e) {
                // Failed to find any iframes on dashboard, ignore.
                return;
            }
            // all frames which are extensions
            const iframes = document.getElementsByTagName('iframe');
            const elementsFrames = this.applyDrag(iframes);
            this.applyMessageOperations(elementsFrames);

            // MutationObserver Logic to control the mobility part (div) of the extension window
            // const targetDiv = document.getElementById('elements-drag-overlay');
        
            // const resetHeight = () => {
            //     if (targetDiv) {
            //         targetDiv.style.setProperty('height', '38px', 'important');
            //     }
            // };

            // const mutationObserver = new MutationObserver((mutations) => {
            //     mutations.forEach((mutation) => {
            //       if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            //         const currentHeight = targetDiv?.style.height;
            //         if (currentHeight && currentHeight !== '38px') {
            //           resetHeight();
            //           console.log("MutationObserver Height CHANGE");
            //         }
            //       }
            //     });
            // });

            // const observerConfig: MutationObserverInit = {
            //     attributes: true,
            //     attributeFilter: ['style'],
            // };
              
            // if (targetDiv) {
            //     mutationObserver.observe(targetDiv, observerConfig);
            // }
        });
    }
    private applyMessageOperations(elementsFrames: HTMLIFrameElement[]) {
        if (elementsFrames.length > 0) {
            let enrichedContext: any = undefined;
            // subscribe for EnrichedContextResponses from parent (vizportal) window. This might not come, if there is no vizportal sitting on top of us
            window.addEventListener('message', event => {
                if (!event || event.type !== 'message' || !event.data) {
                    return;
                }
                // if the message is the response we were looking for from vizportal
                if (event.data.type === 'ElementsEnrichedContextResponse') {
                    enrichedContext = event.data.data;
                    for (var i = 0; i < elementsFrames.length; i++) {
                        // send enriched context straight away - Elements may not be loaded though
                        elementsFrames[i].contentWindow!.postMessage({
                            type: 'ElementsEnrichedContext',
                            data: enrichedContext
                        }, "*");
                    }
                }
                if (event.data.type === 'ElementsLoaded' && enrichedContext) {
                    // elements was loaded after we got enriched context, re-send
                    event.source!.postMessage({
                        type: 'ElementsEnrichedContext',
                        data: enrichedContext
                    }, { targetOrigin: '*' });
                }
            }, false);
            // call EnrichedContextRequest to parent (vizportal)
            window.parent.postMessage({
                type: 'ElementsEnrichedContextRequest'
            },
                "*");
        }
    }
    // applies dragging to Elements frames and returns them for further processing
    private applyDrag(iframes: HTMLCollectionOf<HTMLIFrameElement>): HTMLIFrameElement[] {
        let moveableWindowApplied = 0;
        const ret: HTMLIFrameElement[] = [];
        for (let i = 0; i < iframes.length; i++) {
            const f = iframes[i];
            // if this iframe is not elements
            if (!f.src || !f.src.endsWith('/extensions/annotation')) {
                continue;
            }
            ret.push(f);
            // apply movable window if not already applied
            if (!f.classList.contains('moveable-patched')) {
                // get the zone area of the extension frame
                var zone = this.findParentWithClassName(f, 'tab-zone');
                if (zone) {
                    // only continue if we found the zone

                    // get all other zones that are in the same position and same size as current zone (sometimes extensions are spanned across multiple zones in tableau)
                    const allZones = zone.parentElement!.children;
                    const interestedZones: HTMLElement[] = [];
                    const z = <HTMLElement>zone;
                    for (let childIndex = 0; childIndex < allZones.length; childIndex++) {
                        var curZone = <HTMLElement>allZones[childIndex]!;
                        if (curZone.style.width === z.style.width &&
                            curZone.style.height === z.style.height &&
                            curZone.style.top === z.style.top &&
                            curZone.style.left === z.style.left) {
                            interestedZones.push(curZone);
                        }
                    }

                    // Create draggable element header in the extension zone
                    var overlayElement = document.createElement('div');
                    overlayElement.classList.add('elements-drag-overlay');
                    overlayElement.setAttribute('id', 'elements-drag-overlay');
                    overlayElement.style.setProperty('height', '38px', 'important');
                    overlayElement.style.setProperty('max-height', '38px', 'important');
                    overlayElement.style.position = 'absolute';
                    overlayElement.style.top = '0';
                    overlayElement.style.width = 'calc(100% - 50px)';
                    overlayElement.style.cursor = 'grab';
                    overlayElement.style.zIndex = '1000';
                    f.parentElement!.insertBefore(overlayElement, f);
                    f.classList.add('moveable-patched');
                    this.dragElement(window, interestedZones, f.parentElement!);
                    moveableWindowApplied++;
                }
            }
        }
        console.log('Applied extension drag for ' + moveableWindowApplied + ' Elements instances');
        return ret;
    }

    private findParentWithClassName(element: Element, className: string): Node | null {
        if (element.classList.contains(className)) {
            return element;
        }
        if (!element.parentElement) {
            return null;
        }
        return this.findParentWithClassName(element.parentElement, className);
    }

    private dragElement(vizqlFrameWindow: Window, elements: HTMLElement[], headerElement: HTMLElement) {
        let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

        headerElement.onmousedown = dragMouseDown;

        function dragMouseDown(e: MouseEvent) {
            e.preventDefault();
            (<HTMLElement>e.target!).style.cursor = 'grabbing';
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            vizqlFrameWindow.document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            vizqlFrameWindow.document.onmousemove = elementDrag;
        }

        function elementDrag(e: MouseEvent) {
            e.preventDefault();
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;

            for (let i = 0; i < elements.length; i++) {
                const element = elements[i];
                // set the element's new position:
                element.style.top = (element.offsetTop - pos2) + "px";
                element.style.left = (element.offsetLeft - pos1) + "px";
            }
        }

        function closeDragElement(e: MouseEvent) {
            (<HTMLElement>e.target!).style.cursor = 'grab';
            // stop moving when mouse button is released:
            vizqlFrameWindow.document.onmouseup = null;
            vizqlFrameWindow.document.onmousemove = null;
        }
    }
}